import { ImageLoaderProps } from 'next/image';

export default function cloudfrontLoader({ src, width }: ImageLoaderProps) {
    const url = new URL(`${src}`);
    if (!url.searchParams.has('dw')) {
        url.searchParams.set('dw', width.toString());
    }
    return url.href;
}
